export default function Footer() {
  const handleScroll = (anchor: string) => {
    const el = document.querySelector(anchor);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" onClick={(e) => { e.preventDefault(); handleScroll('#hero'); }} className="inline-block mb-3">
              <span className="text-xl font-heading font-bold text-background-50">555电影网</span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              555电影网是国内领先的免费高清电影在线观看平台，提供海量全集电影不缓冲秒播放服务，覆盖最新院线大片与经典老片，无需下载即刻畅享流畅观影体验。
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '精选推荐', anchor: '#cards' },
                { label: '平台优势', anchor: '#features' },
                { label: '热门专题', anchor: '#carousel' },
                { label: '影视导航', anchor: '#index' },
              ].map((link) => (
                <a
                  key={link.anchor}
                  href={link.anchor}
                  onClick={(e) => { e.preventDefault(); handleScroll(link.anchor); }}
                  className="block text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* More links */}
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">更多内容</h4>
            <div className="space-y-2">
              {[
                { label: '热门排行', anchor: '#ranking' },
                { label: '观众热评', anchor: '#comments' },
                { label: '最新动态', anchor: '#updates' },
                { label: '常见问题', anchor: '#faq' },
              ].map((link) => (
                <a
                  key={link.anchor}
                  href={link.anchor}
                  onClick={(e) => { e.preventDefault(); handleScroll(link.anchor); }}
                  className="block text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">合作伙伴</h4>
            <div className="space-y-2">
              <p className="text-sm text-background-500">合作伙伴信息即将上线</p>
              <p className="text-sm text-background-500">敬请期待</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 555电影网. 本站内容仅供学习交流使用.
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleScroll('#contact'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">
              联系我们
            </a>
            <a href="#about" onClick={(e) => { e.preventDefault(); handleScroll('#about'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">
              关于我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}